import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';

export const caseLogValues = (caseState, uiEngineProps) => ({
  caseLogXml: resolvers.getComponentValues(caseState, uiEngineProps, 'CaseLogXmlObjectBlob').valueItem
});
